export const numbersForYearBuildFilter = Array.from({ length: 23 }, (_, i) => new Date().getFullYear() - i * 5)
  .concat(0)
  .reverse();
